import { components } from "@leafly-com/consumer-api-fetch/dist/openapi";

import { Coordinates } from "@/custom-types/Coordinates";

export type StoreResults = components["schemas"]["StoresV1Data"];

export type Store = components["schemas"]["StoresV1Stores"];

export type Address = components["schemas"]["StoreAddress"];

export type CardConfigurations = components["schemas"]["StoreConfigurations"];

export type MapMarker = components["schemas"]["StoreMapMarker"];

export type StoreMetadata = components["schemas"]["StoresV1Metadata"];
export type StoresV1Pagination = StoreMetadata["pagination"];

export type StoreSeo = components["schemas"]["StoresV1SeoMetadata"];
export type CurrentStatus = components["schemas"]["StoreOpenStatus"];

// Possible types: prominent-image-container, image-container, prominent-icon, icon
export type MapMarkerDisplayType = MapMarker["displayType"];

// Possible types: delivery, storefront
export type MapMarkerLocationType = MapMarker["locationType"];

export enum MapMarkerDisplayTypeEnum {
  ProminentImageContainer = "prominent-image-container",
  ImageContainer = "image-container",
  ProminentIcon = "prominent-icon",
  Icon = "icon",
}

export enum MapMarkerLocationTypeEnum {
  Delivery = "delivery",
  Storefront = "storefront",
}

export type SwipeState = {
  dragging: boolean;
  position: number | null;
};

export type MapData = {
  center?: Coordinates;
  zoom?: number;
  bounds?: google.maps.LatLngBoundsLiteral;
};

export enum DispensaryTypes {
  "dispensaries" = "dispensary",
  "cbd-stores" = "cbd-store",
  "medical-marijuana-doctors" = "clinic",
}
